import { LenderApproval } from '../types';

/**
 * Shown whenever fewer than 2 real approved submissions exist on the VO.
 * Illustrates the compare-approvals feature with realistic-looking placeholder data.
 */
export const EXAMPLE_APPROVAL: LenderApproval = {
  id: 'example-approval',
  lenderName: 'Trnsact Example Lender',
  isExample: true,
  approvalTerms: {
    approvedAmount: 81182,
    interestRate: 8.99,
    termLengthMonths: 60,
    monthlyPayment: 1241.09,
    conditions: [
      { id: 'ex-c1', description: 'Example Condition 1' },
      { id: 'ex-c2', description: 'Example Condition 2' },
      { id: 'ex-c3', description: 'Example Condition 3' },
    ],
    lenderFees: [{ feeName: 'Doc Fees', amount: 2250, canBeFinanced: null, description: null }],
  },
};
